// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged  } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBZwhjdM74EvgWYmB7GmHWGZW2c1WQz2uM",
  authDomain: "morrisyluna.firebaseapp.com",
  projectId: "morrisyluna",
  storageBucket: "morrisyluna.appspot.com",
  messagingSenderId: "871345265853",
  appId: "1:871345265853:web:b8608665f61dd5a5e22bd4",
  measurementId: "G-T5TL4ZV0R7"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

// Helper para esperar token (renueva cuando toque)
export async function getIdToken(): Promise<string> {
  const user = auth.currentUser;
  if (user) return await user.getIdToken(true);

  // Si no hay user aún, espera a que cargue el estado
  const token = await new Promise<string>((resolve, reject) => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      try {
        unsub();
        if (!u) return reject(new Error('No authenticated user'));
        const t = await u.getIdToken();
        resolve(t);
      } catch (e) { reject(e); }
    });
    // opcional: timeout
    setTimeout(() => reject(new Error('Auth timeout')), 10000);
  });
  return token;
}
